import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { ErrorMessage, Formik, useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchempprecloseLoannumber, saveLoanfreezedetails, fetchemployeeloanfreeze } from "store/actions";
import Loader from "common/pageLoader";
import CustomDatePicker from "common/CustomDatePicker";
import CustomMonthPicker from "common/CustomMonthPicker";

const PayrollLoanFreeze = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [data, setData] = useState([]);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  const {
    employees,
    employeeloannumber,
    employeefreezelist,
    loading,
    success,
    error,
    saveSuccess,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    employeeloannumber: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeloannumber ?? [],
    employeefreezelist: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeefreezelist ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveSuccess,
  }));

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedLoan, setSelectedLoan] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    const formData = new FormData();
    formData.append("unit_id", unitId);
    dispatch(fetchemployeeloanfreeze(formData));
  }, [dispatch]);

  const findEmpgetloannumber = (empdata) => {
    if (empdata) {
      const formData = new FormData();
      formData.append("emp_id", empdata.value);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchempprecloseLoannumber(formData));
    }
  }

  const loanOptions = Array.isArray(employeeloannumber) ? employeeloannumber.map((loan) => ({
    value: loan.loan_id,
    label: loan.loan_no,
    outstanding_amount: loan.outstanding_amount,
    Total_Installments: loan.Total_Installments,
    Total_Amount: loan.Total_Amount,
    instalment_date: loan.instalment_date,
  })) : [];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      employee: "",
      postponedType: "Employee",
      remarks: "",
      preCloseDate: "",
      loanNumber: "",
      postponedMonth: ""
    },
    validationSchema: Yup.object().shape({
      employee: Yup.string().nullable().required("Employee Code is required"),
      loanNumber: Yup.string().required("Loan Number is required"),
      remarks: Yup.string().required("Remarks is required"),
      postponedMonth: Yup.date().required("Postponed Month is required").test("is-greater", "Postponed Month must be greater than Next Due Date",
        function (value) {
          const { nextDueDate } = this.parent;
          if (!value || !nextDueDate) return true;
          return new Date(value) > new Date(nextDueDate);
        }
      ),
    }),
    onSubmit: (values) => {
      // console.log("Form Data", values);
      const formData = new FormData();
      formData.append("emp_id", selectedEmployee.value);
      formData.append("loan_id", selectedLoan.value);
      formData.append("loan_type_id", formik.values.postponedType === "Employee" ? 1 : 0);
      formData.append("loan_amount", values.loanAmount);
      formData.append("outstanding_amount", values.outstandingPrincipal);
      formData.append("no_of_installment", values.installments);
      formData.append("next_due_date", values.nextDueDate);
      formData.append("post_due_date", values.postponedMonth);
      formData.append("remarks", values.remarks);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(saveLoanfreezedetails(formData));
      handleReset();
    },
  });

  useEffect(() => {
    if (employeefreezelist?.length > 0) {
      const generatedData = employeefreezelist.map((emp, index) => ({
        sno: index + 1,
        emp_no: emp.emp_no,
        emp_name: emp.emp_name,
        loan_no: emp.loan_no,
        loan_type: emp.loan_type,
        outstanding_amount: emp.outstanding_amount,
        loan_amount: emp.loan_amount,
        no_of_installment: emp.no_of_installment,
        payable_amount: emp.payable_amount,
        start_date: emp.start_date,
        end_date: emp.end_date,
        create_by: emp.create_by,
        create_date: emp.create_date,
        loan_status: emp.loan_status
      })) || [];

      setData(generatedData);
    } else {
      setData([]);
    }
  }, [employeefreezelist]);

  const columns = [
    { Header: "S.No", Cell: ({ row }) => data.length - row.index, width: 70 },
    { Header: "CODE", accessor: "emp_no", width: 120 },
    { Header: "NAME", accessor: "emp_name", width: 180 },
    { Header: "LOAN NUMBER", accessor: "loan_no", width: 150 },
    { Header: "LOAN TYPE", accessor: "loan_type", width: 120 },
    { Header: "OUTSTANDING AMOUNT", accessor: "outstanding_amount", width: 120 },
    { Header: "LOAN AMOUNT", accessor: "loan_amount", width: 120 },
    { Header: "PAYABLE AMOUNT", accessor: "no_of_installment", width: 120 },
    { Header: "START DATE", accessor: "payable_amount", width: 120 },
    { Header: "END DATE", accessor: "start_date", width: 120 },
    { Header: "TOTAL", accessor: "end_date", width: 120 },
    { Header: "CREATED BY", accessor: "create_by", width: 120 },
    { Header: "CREATED DATE", accessor: "create_date", width: 120 },
    { Header: "STATUS", accessor: "loan_status", width: 120 },
    {
      Header: "Actions",
      Cell: ({ row }) => {
        const { id } = row.original;
        return (
          <div className="d-flex gap-3">
            <Link to="#" className="text-danger" onClick={() => handleDelete(id)}>
              <i className="mdi mdi-close-circle font-size-18" id={`deletetooltip-${id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${id}`}>
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        );
      },
    },
  ];

  const resetFormData = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    setSelectedEmployee(null);
    formik.resetForm({
      values: {
        employee: "",
        loanNumber: "",
        outstandingPrincipal: "0",
        empName: "",
        preCloseAmount: "0",
        balanceAmount: "0",
        installments: "0",
        installmentAmount: "0",
      },
    });
  };

  const handleReset = () => {
    formik.resetForm({
      values: {
        employee: "",
        loanNumber: "",
        outstandingPrincipal: "0",
        empName: "",
        preCloseAmount: "0",
        balanceAmount: "0",
        installments: "0",
        installmentAmount: "0",
      }
    });
  };

  useEffect(() => {
    if (saveSuccess) {
      dispatch({ type: "RESET_SAVE_STATUS" });
      resetFormData();
    }
  }, [saveSuccess, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll / Employee Loan" breadcrumbItem="Loan Freeze" />

          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  {/* Postponed Type */}
                  <Col md={4}>
                    <FormGroup>
                      <Label>Postponed Type</Label> <span className="text-danger">*</span>
                      <div className="d-flex">
                        <Label className="me-3">
                          <Input type="radio" name="postponedType" value="Employee"
                            onChange={formik.handleChange} checked={formik.values.postponedType === "Employee"} />
                          Employee
                        </Label>
                        <Label>
                          <Input type="radio" name="postponedType" value="All"
                            onChange={formik.handleChange} checked={formik.values.postponedType === "All"} />
                          All
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>

                  {/* Employee (Conditional) */}
                  {formik.values.postponedType === "Employee" && (
                    <Col md={4}>
                      <FormGroup>
                        <Label>Employee </Label><span className="text-danger"> *</span>
                        <CustomSelect
                          id="employee"
                          name="employee"
                          options={employees}
                          value={selectedEmployee}
                          onChange={(selectedOption) => {
                            setSelectedEmployee(selectedOption);
                            if (selectedOption) {
                              formik.setFieldValue("employee", selectedOption.value);
                              findEmpgetloannumber(selectedOption);
                            }
                          }}
                          onBlur={() => formik.setFieldTouched("employee", true)}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          isClearable={true}
                        />
                        {formik.touched.employee && formik.errors.employee && (
                          <div className="text-danger">{formik.errors.employee}</div>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {/* Loan Type */}
                  {/* <Col md={4}>
                    <FormGroup>
                      <Label>Loan Type *</Label>
                      <CustomSelect
                        options={loanTypeOptions}
                        value={loanTypeOptions.find(option => option.value === formik.values.loanType)}
                        onChange={(option) => formik.setFieldValue("loanType", option.value)}
                      />
                      {formik.errors.loanType && <div className="text-danger">{formik.errors.loanType}</div>}
                    </FormGroup>
                  </Col> */}

                  {/* Loan Number (Conditional) */}
                  {formik.values.postponedType === "Employee" && (
                    <Col md={4}>
                      <FormGroup>
                        <Label>Loan Number </Label><span className="text-danger"> *</span>
                        <CustomSelect
                          id="loanNumber"
                          name="loanNumber"
                          options={loanOptions}
                          value={loanOptions?.find((opt) => opt.value === formik.values.loanNumber)}
                          onChange={(option) => {
                            if (!option) return;
                            setSelectedLoan(option);
                            formik.setFieldValue("loanNumber", option.value);
                            formik.setFieldValue("outstandingPrincipal", option.outstanding_amount);
                            formik.setFieldValue("loanAmount", option.Total_Amount);
                            formik.setFieldValue("installments", option.Total_Installments);
                            const formattedDate = option.instalment_date ? new Date(option.instalment_date).toISOString().slice(0, 10) : "";
                            formik.setFieldValue("nextDueDate", formattedDate);
                          }}
                        />
                        {formik.touched.loanNumber && formik.errors.loanNumber && (
                          <div className="text-danger">{formik.errors.loanNumber}</div>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {/* Loan Amount, Outstanding Principal, No. of Installments (Conditional) */}
                  {formik.values.postponedType === "Employee" && (
                    <>
                      <Col md={4}>
                        <FormGroup>
                          <Label>Loan Amount</Label>
                          <Input type="number" name="loanAmount" value={formik.values.loanAmount} disabled />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label>Outstanding Principal</Label>
                          <Input type="number" name="outstandingPrincipal" value={formik.values.outstandingPrincipal} disabled />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label>No. of Installments</Label>
                          <Input type="number" name="installments" value={formik.values.installments} disabled />
                        </FormGroup>
                      </Col>
                    </>
                  )}

                  {/* Next Due Date (Conditional) */}
                  {formik.values.postponedType === "Employee" && (
                    <Col md={4}>
                      <FormGroup>
                        <Label>Next Due Date</Label>
                        <CustomMonthPicker
                          name="nextDueDate"
                          disabled
                          value={formik.values.nextDueDate}
                          onChange={(date) => formik.setFieldValue("nextDueDate", date)}
                          onBlur={formik.handleBlur}
                          disableFuture={true}
                          className={`form-control ${formik.touched.nextDueDate && formik.errors.nextDueDate ? "is-invalid" : ""}`}
                        />
                      </FormGroup>
                    </Col>
                  )}

                  {/* Postponed Month */}
                  <Col md={4}>
                    <FormGroup>
                      <Label>Postponed Month</Label><span className="text-danger"> *</span>
                      <CustomMonthPicker
                        id="postponedMonth"
                        name="postponedMonth"
                        value={formik.values.postponedMonth || ""}
                        onChange={(date) => {
                          if (!date) { formik.setFieldValue("postponedMonth", ""); return; }
                          const selectedDate = new Date(date);
                          const formatted = selectedDate.getFullYear() + "-" + String(selectedDate.getMonth() + 1).padStart(2, "0") + "-01";
                          formik.setFieldValue("postponedMonth", formatted);
                        }}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.postponedMonth && formik.errors.postponedMonth ? "is-invalid" : ""}`}
                      />
                      {formik.touched.postponedMonth && formik.errors.postponedMonth && (
                        <div className="text-danger">{formik.errors.postponedMonth}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Due Month (Conditional) */}
                  {formik.values.postponedType === "All" && (
                    <Col md={4}>
                      <FormGroup>
                        <Label>Due Month </Label><span className="text-danger"> *</span>
                        <CustomMonthPicker
                          name="dueMonth"
                          value={formik.values.dueMonth}
                          onChange={(date) => formik.setFieldValue("dueMonth", date)}
                          onBlur={formik.handleBlur}
                          className={`form-control ${formik.touched.dueMonth && formik.errors.dueMonth ? "is-invalid" : ""}`}
                        />
                        {formik.touched.dueMonth && formik.errors.dueMonth && (
                          <div className="text-danger">{formik.errors.dueMonth}</div>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  {/* Remarks */}
                  <Col md={4}>
                    <FormGroup>
                      <Label>Remarks </Label><span className="text-danger"> *</span>
                      <Input type="text" name="remarks" value={formik.values.remarks} onChange={formik.handleChange} />
                      {formik.touched.remarks && formik.errors.remarks && (
                        <div className="text-danger">{formik.errors.remarks}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Submit and Cancel Buttons */}
                  <Col className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className="btn button-save me-2">
                      <i className="fas fa-save me-1" /> Save
                    </Button>
                    <Button type="reset" className="btn button-cancel"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // formik.resetForm();
                            resetFormData();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>


          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data && data?.length > 0 ? data : []}
                isGlobalFilter={true}
                customPageSize={10}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollLoanFreeze;
